<template>
  <div class="min-h-screen flex flex-col bg-[#f2f4ff] dark:bg-gray-900 transition-colors duration-300">
    <!-- Navbar -->
    <header class="sticky top-0 z-50 bg-white/80 dark:bg-gray-800/80 backdrop-blur-md shadow-sm">
      <nav class="container-fluid fm:mx-3 mx-14 sm:px-6 fd:px-8 flex items-center justify-between h-16">
        <div class="flex items-center justify-between fm:gap-4 gap-10">
            <!-- Burger icon -->
             <div>
                <button class="fm:block hidden p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition" @click="toggleSidebar()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-700 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
             </div>
            <!-- Logo -->
            <!-- <div class="flex items-center fm:text-sm">
                <svg class="w-8 h-8 text-indigo-600 dark:text-indigo-400" fill="none" stroke="currentColor" stroke-width="2"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l4 2" />
                    <circle cx="12" cy="12" r="10" />
                </svg>
            </div> -->

            <!-- Menu -->
            <ul :class="[showSidebar ? 'fm:flex' : 'fm:hidden', 'fm:absolute fm:top-16 fm:left-0 fm:w-full fm:bg-white fm:dark:bg-gray-800 fm:shadow-md fm:flex-col fm:space-y-4 fm:p-4 fm:transition-all fm:duration-300', 'flex gap-10']">
            <!-- <li><router-link to="/" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">خانه</router-link></li>
            <li><router-link to="/products" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">محصولات</router-link></li>
            <li><router-link to="/about" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">درباره ما</router-link></li>
            <li><router-link to="/contact" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">تماس</router-link></li> -->
            </ul>
        </div>

        <div class="flex items-center gap-6">
            <div class="p-2 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition">
                <router-link v-if="!$store.state.user.token" to="/login" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition fm:text-sm">ورود/ثبت نام</router-link>
                <router-link v-else to="/dashboard" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition fm:text-sm">پنل کاربری</router-link>
            </div>
            <!-- Right: Theme Toggle -->
            
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <main class="fm:mx-4">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class=" dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div class="max-w-7xl mx-auto py-6 sm:px-6 fd:px-8 flex flex-col sm:flex-row justify-between text-gray-600 dark:text-gray-300 text-sm">
        <div class="flex gap-10">
          <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=7461655&Code=ZG1ic6bL8b2Pie6XaFRORcwU5e0v174u'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=7461655&Code=ZG1ic6bL8b2Pie6XaFRORcwU5e0v174u' alt='' style='cursor:pointer' code='ZG1ic6bL8b2Pie6XaFRORcwU5e0v174u'></a>
        </div>
      </div>
      <div class="flex items-center justify-center mt-4">
        <p class="mb-2 sm:mb-0">{{ new Date().getFullYear() }}&copy;  همه حقوق محفوظ است.</p>
      </div>
    </footer>
  </div>
</template>


<script>
    export default {
        name: 'FrontLayout',
    }
</script>

<script setup>

import { onMounted, ref, watch } from 'vue';


let showSidebar = ref(false)

onMounted(() => {
  
})


function toggleSidebar(){
    showSidebar.value = !showSidebar.value
}
</script>